import React, { useState } from 'react';
import { Button, Card, Col, Input, Popconfirm, Row, Space } from 'antd';
import { DeleteOutlined, EditOutlined, FileTextFilled, PlusOutlined } from '@ant-design/icons';
import { useRequest } from 'ahooks';
import dayjs from 'dayjs';
import { deleteKnowledge, getKnowledgeList, KnowledgeListVo } from '@/api/knowledge';
import './index.scss';
import EditKnowledge from './editModal';
import { useUpdate } from '@/common/hook';

const Knowledge = () => {
  const [editData, setEditData] = useState<KnowledgeListVo>();
  const [visible, setVisible] = useState<boolean>(false);
  const [keyword, setKeyword] = useState<string>();
  const [update, updateFn] = useUpdate();

  const { data, loading } = useRequest(() => getKnowledgeList({ keyword }), { refreshDeps: [update, keyword] });

  return (
    <div className="knowledge-container">
      <div className="flex gap-3 items-center mb-4">
        <Button type="primary" icon={<PlusOutlined />} onClick={() => setVisible(true)}>
          新增知识库
        </Button>
        <Input.Search placeholder="搜索知识库" style={{ width: '300px' }} onSearch={setKeyword} />
      </div>

      <Row gutter={8} className="mt-8 gap-y-2">
        {data?.map(item => (
          <Col span={6} key={item.id}>
            <Card
              loading={loading}
              actions={[
                <EditOutlined
                  key="edit"
                  onClick={() => {
                    setEditData(item);
                    setVisible(true);
                  }}
                />,
                <Popconfirm
                  title="确定删除该知识库？"
                  onConfirm={() =>
                    deleteKnowledge(item.id!).then(() => {
                      updateFn();
                    })
                  }
                >
                  <DeleteOutlined key="setting" />
                </Popconfirm>,
              ]}
              hoverable={true}
            >
              <Card.Meta
                avatar={<FileTextFilled style={{ color: '#286FDC', fontSize: 20 }} />}
                title={item.title}
                key={item.id}
                description={
                  <div className="text-xs">
                    <div className="line-clamp-2 break-words h-8">{item.content}</div>
                    <div className="mt-2 text-right">
                      最近编辑：{dayjs(item.updateTime).format('YYYY-MM-DD HH:mm:ss')}
                    </div>
                  </div>
                }
              />
            </Card>
          </Col>
        ))}
      </Row>
      {visible && (
        <EditKnowledge
          data={editData}
          isEdit={!!editData}
          updateFn={updateFn}
          onCancel={() => {
            setVisible(false);
            setEditData(undefined);
          }}
        />
      )}
    </div>
  );
};

export default Knowledge;
